// @ts-check
import Groups from '@/store/modules/users/models/Groups';
import UserSummary from '@/store/modules/users/models/UserSummary';

const User = UserSummary.extend({
  groups: Groups,
});

export default User;
